import React from "react";
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

const EmailTicketSystemTableSelectorCell = ({ value, onClickUp, onClickDown, onClickDelete }) => {
  const theme = useTheme();
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              fontWeight: "bold",
              width: "100%",
              fontSize: "16px",
              minWidth: "150px",
              m: "auto",
            }}
          >
            {value}
          </Box>
          <Box sx={{ flex: "1 1 100%" }} />
          {onClickUp && (
            <Tooltip title="Sort To Left">
              <IconButton aria-label="left" onClick={() => onClickUp()} size="large">
                <ArrowDropUpIcon />
              </IconButton>
            </Tooltip>
          )}
          {onClickDown ? (
            <Tooltip title="Sort To Right">
              <IconButton aria-label="right" onClick={() => onClickDown()} size="large">
                <ArrowDropDownIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Box sx={{ minWidth: theme.spacing(6), height: theme.spacing(6) }} />
          )}
          {onClickDelete && (
            <Tooltip title="Delete">
              <IconButton aria-label="delete" onClick={() => onClickDelete()} size="large">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

EmailTicketSystemTableSelectorCell.defaultProps = {
  onClickDown: undefined,
  onClickUp: undefined,
  onClickDelete: undefined,
};

EmailTicketSystemTableSelectorCell.propTypes = {
  onClickUp: PropTypes.func,
  onClickDown: PropTypes.func,
  value: PropTypes.string.isRequired,
  onClickDelete: PropTypes.func,
};

export default EmailTicketSystemTableSelectorCell;
